// Libraries
import { Location } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

// UI
import { NoDataComponent } from 'projects/ui-library/src/lib/components/no-data/no-data.component';
import { ButtonComponent } from 'ui-library';

export interface ErrorPageData {
    icon: string;
    message: string;
    description: string;
}

@Component({
    selector: 'app-error-page',
    standalone: true,
    imports: [
        ButtonComponent,
        NoDataComponent
    ],
    templateUrl: './error-page.component.html',
    styleUrl: './error-page.component.scss'
})

export class ErrorPageComponent {
    // Services
    private readonly location: Location = inject(Location);
    private readonly router: Router = inject(Router);
    private readonly route: ActivatedRoute = inject(ActivatedRoute);

    // Data from route
    icon: string = 'error';
    message: string = 'error.title';
    description: string = 'error.description';

    constructor() {
        const data = this.route.snapshot.data as ErrorPageData;
        if (data.icon) this.icon = data.icon;
        if (data.message) this.message = data.message;
        if (data.description) this.description = data.description;
    }

    goBack(): void {
        this.location.back();
    }

    goHome(): void {
        this.router.navigate(['/projects']);
    }
}
